
export class FiltrosTipoAnexo {
    filtroDescricao: string;
    filtroGrupo: string | null;
    filtroObrigatorio: boolean | null;
    filtroTipoEdital: string[];

    constructor(obj?: any) {
        this.filtroDescricao = obj?.filtroDescricao ?? '';
        this.filtroGrupo = obj?.filtroGrupo ?? null;
        this.filtroObrigatorio = obj?.filtroObrigatorio ?? null;
        this.filtroTipoEdital = obj?.filtroTipoEdital ?? [];
    }

    limpar(): void {
        this.filtroDescricao = '';
        this.filtroGrupo = null;
        this.filtroObrigatorio = null;
        this.filtroTipoEdital = [];
    }
}
